import React, { memo } from "react";
import styled from "styled-components";
import { RoundedIcon } from "../rounded-icon/rounded-icon";
import { moduleSettings } from "../../stores/module-settings.store";
import { useTranslation } from "react-i18next";

const BackgroundContentWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  background-color: white;
  border-radius: 5px;
  margin: 32px 0;
`;

const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.primaryColor}20;
  color: ${(props) => props.theme.informationTextColor};
  text-align: center;
  border-radius: 5px;
  padding: 12px 22px;
  width: 100%;
`;

const Title = styled.div`
  color: ${(props) => props.theme.primaryColor};
  text-align: center;
  width: 100%;
`;

const RestaurantName = styled.div`
  font-size: 16px;
`;

const RestaurantCity = styled.div`
  font-size: 12px;
`;

const LinkButton = styled.a<{ background?: string }>`
  display: inline-block;
  text-align: center;
  padding: 10px;
  margin: 0 12px;
  background: transparent;
  color: ${(props) => props.theme.primaryColor};
  font-size: 16px;
  font-weight: 400;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.primaryColor};
  text-decoration: none;
  cursor: pointer;
  transition: border 0.2s;
  &:hover {
    color: ${(props) => props.theme.invertFontColor};
    background: ${(props) => props.theme.primaryColor};
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 12px;
  gap: 8px;
`;

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

const RestaurantGroupSuggestionsComponent = () => {
  const { t } = useTranslation();
  const mappedText = t("restaurant_group_suggestions");
  const restaurantsToSuggest = moduleSettings.restaurantToSuggest || [];

  return (
    <BackgroundContentWrapper data-test="restaurant-group-suggestions">
      <ContentWrapper>
        <RoundedIcon
          icon="restaurant-group"
          size="large"
          border={true}
          position="left"
        />
        <ContentColumn>
          <Title
            dangerouslySetInnerHTML={{ __html: mappedText }}
            data-test="text-title"
          />
          <ButtonsWrapper>
            {restaurantsToSuggest.map((restaurant) => (
              <LinkButton
                key={restaurant.id}
                href={restaurant.module_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ margin: "8px 0" }}
                data-test="restaurant-link"
              >
                <RestaurantName>{restaurant.name}</RestaurantName>
                <RestaurantCity>{restaurant.city}</RestaurantCity>
              </LinkButton>
            ))}
          </ButtonsWrapper>
        </ContentColumn>
      </ContentWrapper>
    </BackgroundContentWrapper>
  );
};
export const RestaurantGroupSuggestions = memo(
  RestaurantGroupSuggestionsComponent
);
